import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-grow px-4 py-2 md:px-12 md:py-4 w-full" }
const _hoisted_2 = {
  id: "main-content",
  class: "text-muted text-lg"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm text-yellow-600 dark:text-yellow-500"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "i-svg-spinners:90-ring-with-bg h-4 w-4 mr-2",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only"
}
const _hoisted_8 = {
  key: 0,
  role: "status"
}
const _hoisted_9 = {
  key: 1,
  role: "alert",
  class: "text-red-600 dark:text-red-400"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ama',
  setup(__props) {

const status = ref<'idle' | 'pending' | 'error' | 'success'>('idle')

const denialDetected = ref(false)
const questionText = ref('')

const statusMessage = computed(() => {
  if (status.value === 'pending') return 'Submitting question...'
  if (status.value === 'success') return 'Question submitted successfully!'
  if (status.value === 'error') return 'Error submitting question. Please try again.'
  return ''
})

watchEffect(() => {
  denialDetected.value = /[Dd]enial/.test(questionText.value)
})

function fixDenial () {
  questionText.value = questionText.value.replace(/[Dd]enial/g, 'Daniel')
  denialDetected.value = false
}

async function askQuestion () {
  if (status.value === 'pending') return
  if (!questionText.value.trim()) return

  if (denialDetected.value) {
    status.value = 'idle'
    return
  }

  try {
    status.value = 'pending'

    await apiFetch('/api/question', {
      method: 'POST',
      body: {
        question: questionText.value,
      },
    })

    status.value = 'success'
    questionText.value = ''
  }
  catch (error) {
    console.error(error)
    status.value = 'error'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("form", {
        class: _normalizeClass(["flex flex-col items-start py-8 gap-2", { 'opacity-50 pointer-events-none': _unref(status) === 'pending' }]),
        onSubmit: _withModifiers(askQuestion, ["prevent"])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, [
          _createElementVNode("label", {
            for: "question",
            class: "text-2xl leading-none mt-[5vw] mb-[1vw] max-w-[37.50rem]"
          }, " ask me anything ")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, [
          _createTextVNode(" I'll try to "),
          _createElementVNode("a", {
            class: "underlined-link",
            href: "https://bsky.app/hashtag/ama?author=danielroe.dev",
            target: "_blank",
            rel: "noopener noreferrer"
          }, " answer it on social media "),
          _createTextVNode(". ")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm text-muted" }, " If I answer them they'll appear publicly on social media. Don't include anything you wouldn't want public. ", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "question",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(questionText) ? (questionText).value = $event : null)),
          name: "question",
          rows: "4",
          autocomplete: "off",
          class: _normalizeClass(["mt-2 rounded w-full max-w-400px min-h-[10ch] bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 px-3 py-2 text-base f-ring-inset", {
            'ring ring-yellow-600 dark:ring-yellow-500': _unref(denialDetected),
          }]),
          disabled: _unref(status) === 'pending' || _unref(status) === 'success'
        }, null, 10, _hoisted_3), [
          [_vModelText, _unref(questionText)]
        ]),
        (_unref(denialDetected))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _cache[1] || (_cache[1] = _createTextVNode(" Did you mean ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "underline font-medium hover:opacity-80 rounded f-ring px-1 py-0.5",
                  onClick: fixDenial
                }, " \"Daniel\" "),
                _cache[2] || (_cache[2] = _createTextVNode("? ", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          disabled: _unref(status) === 'pending' || _unref(status) === 'success' || !_unref(questionText).trim(),
          class: "underlined-link outline-none focus-visible:after:opacity-35 py-2 disabled:opacity-50"
        }, [
          (_unref(status) === 'pending')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          (!_unref(denialDetected))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" ask anonymously ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" no, submit question anyway ")
              ], 64))
        ], 8, _hoisted_5)
      ], 34),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(statusMessage)), 1),
      (_unref(status) === 'success')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("p", null, [
              _createElementVNode("span", {
                class: "i-ri-checkbox-fill text-green-600 dark:text-green-400",
                "aria-hidden": "true"
              }),
              _createTextVNode(" question submitted successfully! ")
            ], -1)),
            _createElementVNode("p", null, [
              _createVNode(_component_NuxtLink, {
                to: "/",
                class: "underlined-link"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" go home ", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : (_unref(status) === 'error')
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("span", {
                class: "i-ri-error-warning-fill",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" an error occurred. Please try again. ", -1)
            ]))]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})